export default {
    text: {
        title: 'Tekst',
        addText: 'Nieuwe tekst',
        fontFamily: 'Lettertype',
        fontSize: 'Font size',
        textAlignment: 'Tekstuitlijning',
        fontColor: 'Kleur van de lettertype',
        lineSpacing: 'Regelafstand',
        arialSerif: 'Arial (sans-serif)',
        verdanaSansSerif: 'Verdana (sans-serif)',
        tahomaSansSerif: 'Tahoma (sans-serif)',
        trebuchetMSSansSerif: 'Trebuchet MS (schreefloos)',
        timesNewRomanSerif: 'Times New Roman (schreef)',
        georgiaSerif: 'Georgië (schreef)',
        garamondSerif: 'Garamond (schreef)',
        courierNewMonospace: 'Courier New (monospace)',
        brushScriptMTCursive: 'Penseelschrift MT (cursief)',
        backgroundColor: 'Achtergrondkleur',
    },
};
